import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSliderLong = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 12,
	viewBox: "0 0 14 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.66732 0C6.42476 0 5.38069 0.849849 5.08466 2H1.00065C0.632461 2 0.333984 2.29848 0.333984 2.66667C0.333984 3.03486 0.632461 3.33333 1.00065 3.33333H5.08466C5.38069 4.48349 6.42476 5.33333 7.66732 5.33333H8.33398C9.80674 5.33333 11.0007 4.13943 11.0007 2.66667C11.0007 1.19391 9.80674 0 8.33398 0H7.66732Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.334 2C11.9658 2 11.6673 2.29848 11.6673 2.66667C11.6673 3.03486 11.9658 3.33333 12.334 3.33333H13.0007C13.3688 3.33333 13.6673 3.03486 13.6673 2.66667C13.6673 2.29848 13.3688 2 13.0007 2H12.334Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.00065 6.66667C3.75809 6.66667 2.71402 7.51652 2.418 8.66667H1.00065C0.632461 8.66667 0.333984 8.96514 0.333984 9.33333C0.333984 9.70152 0.632461 10 1.00065 10H2.418C2.71402 11.1502 3.75809 12 5.00065 12H5.66732C7.14008 12 8.33398 10.8061 8.33398 9.33333C8.33398 7.86057 7.14008 6.66667 5.66732 6.66667H5.00065Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.66732 8.66667C9.29913 8.66667 9.00065 8.96514 9.00065 9.33333C9.00065 9.70152 9.29913 10 9.66732 10H13.0007C13.3688 10 13.6673 9.70152 13.6673 9.33333C13.6673 8.96514 13.3688 8.66667 13.0007 8.66667H9.66732Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgSliderLong);
export default ForwardRef;
